import { render, staticRenderFns } from "./TechOption.vue?vue&type=template&id=745ad5b0&"
import script from "./TechOption.vue?vue&type=script&lang=js&"
export * from "./TechOption.vue?vue&type=script&lang=js&"
import style0 from "./TechOption.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseCopy: require('/opt/build/repo/storefront/components/atoms/Text/BaseCopy.vue').default})
